howspace.components.lister = (() => {
    'use strict';

    const observedTables = [];

    const recalculateObservedTableTheadTop = observedTable => {
        const top = Math.max(0, window.scrollY + observedTable.topHeight - observedTable.tableOffsetTop);
        observedTable.thead.css('top', top + 'px');
    };

    const tableResizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            let observedTable = null;
            real.loop(observedTables, (loopObservedTable) => {
                if (loopObservedTable.table[0] === entry.target) {
                    observedTable = loopObservedTable;
                    return false;
                }
            });

            if (observedTable === null) {
                return;
            }

            observedTable.tableWidth = observedTable.table.width();
            observedTable.tableOffsetTop = observedTable.table.offset().top;
            observedTable.listerItemsWidth = observedTable.listerItems.width();

            if (observedTable.tableWidth <= observedTable.listerItemsWidth) {
                observedTable.listerItems.removeClass('horizontal-scroll');
                observedTable.thead.css('top', '');
            } else {
                observedTable.listerItems.addClass('horizontal-scroll');
                recalculateObservedTableTheadTop(observedTable);
            }
        }
    });

    window.addEventListener('scroll', () => {
        observedTables.forEach((observedTable) => {
            if (observedTable.tableWidth <= observedTable.listerItemsWidth) {
                // Table width does not exceed the lister items width.
                return;
            }

            // Lister items has horizontal scroll so thead does not stick via pure CSS.
            if (observedTable.timeoutId !== null) {
                // Clear previous timeout.
                clearTimeout(observedTable.timeoutId);
            }

            // Set new timeout to recalculate scroll table thead top position.
            observedTable.timeoutId = setTimeout(() => {
                observedTable.timeoutId = null;
                recalculateObservedTableTheadTop(observedTable);
            }, 100);
        });
    }, {
        capture : true,
        passive : true
    });

    const startObservingTable = (table) => {
        if (table.length === 0) {
            return;
        }
        tableResizeObserver.observe(table[0]);
        const listerItems = table.closest('.howspace-lister-items');
        observedTables.push({
            table : table,
            tableOffsetTop : table.offset().top,
            tableWidth : table.width(),
            thead : table.find('thead'),
            listerItems : listerItems,
            listerItemsWidth : listerItems.width(),
            topHeight : $('#top').height(),
            timeoutId : null
        });
    };

    const stopObservingTable = (table) => {
        if (table.length === 0) {
            return;
        }
        tableResizeObserver.unobserve(table[0]);
        real.loop(observedTables, (observedTable, index) => {
            if (observedTable.table[0] === table[0]) {
                observedTables.splice(index, 1);
            }
        });
    };

    const transition = (
        lister,
        hideElem,
        showElem,
        showReadyFn,
        hideReadyFn,
        beforeCalculateHeight,
        afterCalculateHeight
    ) => {
        const loadMoreButton = lister.find('.lister-load-more-btn');
        const animDuration = howspace.getAnimationDuration(lister, '--transition-animation-duration');

        const hasMoreItems = lister.data('has-more-items');

        const animator = new real.animator()
            .setParentElement(lister)
            .setHideElement(hideElem)
            .setShowElement(showElem)
            .setAnimDuration(animDuration)
            .beforeCalculateHeight(() => {
                if (hasMoreItems) {
                    loadMoreButton.removeClass('d-none');
                }
                if (typeof beforeCalculateHeight === 'function') {
                    animator.beforeCalculateHeight(beforeCalculateHeight);
                }
            })
            .afterCalculateHeight(() => {
                if (hasMoreItems) {
                    loadMoreButton.addClass('d-none');
                }
                if (typeof afterCalculateHeight === 'function') {
                    animator.afterCalculateHeight(afterCalculateHeight);
                }
            })
            .onShowReady(() => {
                showElem.css({display: '', opacity: ''});
                if (typeof showReadyFn === 'function') {
                    showReadyFn();
                }
            })
            .onHideReady(() => {
                requestAnimationFrame(() => {
                    if (hasMoreItems && loadMoreButton.length > 0) {
                        loadMoreButton.removeClass('d-none');
                        howspace.animate(loadMoreButton, 'fadeIn', animDuration);
                    }
                });
                if (typeof hideReadyFn === 'function') {
                    hideReadyFn();
                }
            });

        animator.startAnimation();
    };

    const getUrl = lister => {
        const dataPayload = real.form.getDataPayload(lister);

        dataPayload.limit = lister.data('first-page-limit') || lister.data('limit') || 24;
        dataPayload.sort_by = lister.data('sort-by');
        dataPayload.sort_order = lister.data('sort-order');

        if (lister.data('filter-by-elem')) {
            // When switching between view and edit mode, there are 2 filterByElem elements available one is for view and one is for edit.
            // We need to get the filterByElem for view mode only.
            const filterByElem = $(lister.data('filter-by-elem') + '[data-widget-mode="view"]').not('.removing');
            if (filterByElem.length > 0) {
                dataPayload.filter = howspace.widgets.getFilter(filterByElem);
            }
        }

        if (lister.data('additional-filter')) {
            if (!dataPayload.filter) {
                dataPayload.filter = {};
            }
            const additionalFilter = lister.data('additional-filter');
            $.extend(dataPayload.filter, additionalFilter);
        }

        const separator = lister.data('uri').indexOf('?') < 0 ? '?' : '&';
        return lister.data('uri') + separator + $.param(dataPayload);
    };

    const renderListItems = (lister, response) => {
        const cards = lister.find('.howspace-lister-cards');
        const table = lister.find('.howspace-lister-table');
        const reloadWithoutAnimation = lister.data('reload-without-animation');

        if (reloadWithoutAnimation) {
            lister.dataAndAttr('reload-without-animation', false);
            cards.html('');
            table.find('tbody').html('');
        }

        lister.dataAndAttr('total-items', response['total_items']);
        lister.dataAndAttr('has-more-items', !!response['next_page_href']);

        if (table.find('tbody tr').length === 0 && cards.html().trim() === '') {
            showFirstPageOfItems(lister, response, reloadWithoutAnimation);
        } else {
            showSubsequentPageOfItems(lister, response);
        }
    };

    const getUniqueItems = (parent, html) => {
        const newItems = $(html);
        const removeIndexes = [];

        newItems.each((i, newItem) => {
            if (newItem.id && parent.children('#' + newItem.id).length > 0) {
                // Item already exists in the parent. Just collect index at this point.
                removeIndexes.push(i);
            }
        });

        // Loop the indexes (if any) in reverse order and remove items which already exist in the parent.
        real.loopReverse(removeIndexes, (index) => {
            newItems.splice(index, 1);
        });

        return newItems;
    };

    const showFirstPageOfItems = (lister, response, reloadWithoutAnimation) => {
        const mode = lister.data('mode');
        const loader = lister.find('.howspace-lister-loader');
        const cards = lister.find('.howspace-lister-cards');
        const table = lister.find('.howspace-lister-table');
        const noItems = lister.find('.howspace-lister-no-items');
        const emptyState = lister.find('.howspace-lister-empty-state');
        const newRows = getUniqueItems(table, response.table_html);
        const newCards = getUniqueItems(cards, response.cards_html);
        const isChecked = lister.find('.howspace-table thead th:first-child input[type="checkbox"]').prop('checked');

        table.find('tbody').html(newRows);
        cards.append(newCards);

        howspace.components.init(newRows);
        howspace.components.init(newCards);

        loader.hide();
        table.show();
        cards.show();
        noItems.show();
        emptyState.show();
        howspace.dispatchEvent(lister, howspace.components.lister.LIST_ITEMS_LOADED, response);
        loader.show();
        table.hide();
        cards.hide();
        noItems.hide();
        emptyState.hide();

        if (lister.data('tab-selector')) {
            const tab = $(lister.data('tab-selector'));
            if (tab.find('.howspace-lister-items-count').length === 0) {
                tab.append('<span class="howspace-lister-items-count"></span>');
            }
            tab.find('.howspace-lister-items-count').html('(' + response['total_items'] + ')');
        }

        if (response['empty_state'] && emptyState.length > 0) {
            transition(lister, loader, emptyState, () => {
                emptyState.show();
                lister.addClass('no-items empty-state');
                howspace.dispatchEvent(lister, howspace.components.lister.LIST_ITEMS_RENDERED);
                real.infiniteScroll.resume(lister);
            });
        } else if (response['total_items'] === 0) {
            const showReadyFn = () => {
                noItems.show();
                lister.removeClass('loading').addClass('no-items');
                if (response.next_page_href) {
                    // A page can come back empty while the source still has more, so keep the way forward visible.
                    // The animated path below covers this through transition(), the non animated one does not.
                    lister.find('.lister-load-more-btn.d-none').removeClass('d-none');
                }
                howspace.dispatchEvent(lister, howspace.components.lister.LIST_ITEMS_RENDERED);
                real.infiniteScroll.resume(lister);
            };
            if (reloadWithoutAnimation) {
                loader.hide();
                showReadyFn();
            } else {
                transition(lister, loader, noItems, showReadyFn);
            }
        } else {
            const showReadyFn = () => {
                if (response.next_page_href) {
                    lister.find('.lister-load-more-btn.d-none').removeClass('d-none');
                }
                howspace.dispatchEvent(lister, howspace.components.lister.LIST_ITEMS_RENDERED, response);
            };
            const hideReadyFn = () => {
                lister.removeClass('loading no-items empty-state');
                if (lister.is('.real-infinite-scroll-initialized') && lister.is(':visible')) {
                    real.infiniteScroll.resume(lister);
                }
            };
            if (mode === 'table') {
                const showTableReadyFn = () => {
                    startObservingTable(table);
                    if (isChecked) {
                        requestAnimationFrame(() => {
                            table.find('tbody > *:first-child input[type="checkbox"]').prop('checked', true);
                        });
                    }
                    showReadyFn();
                };
                if (reloadWithoutAnimation) {
                    loader.hide();
                    table.show();
                    showTableReadyFn();
                } else {
                    transition(lister, loader, table, showTableReadyFn, hideReadyFn);
                }
            } else if (reloadWithoutAnimation) {
                loader.hide();
                cards.show();
                showReadyFn();
            } else {
                transition(lister, loader, cards, showReadyFn, hideReadyFn);
            }
        }
    };

    const showSubsequentPageOfItems = (lister, response) => {
        const cards = lister.find('.howspace-lister-cards');
        const table = lister.find('.howspace-lister-table');
        const newRows = getUniqueItems(table, response.table_html);
        const newCards = getUniqueItems(cards, response.cards_html);
        const isChecked = lister.find('.howspace-table thead th:first-child input[type="checkbox"]').prop('checked');

        lister.removeClass('loading no-items');

        if (isChecked) {
            requestAnimationFrame(() => {
                table.find('tbody > *:first-child input[type="checkbox"]').prop('checked', true);
            });
        }

        // Animate list to new height.
        const origHeight = lister.height();
        table.find('tbody').append(newRows);
        cards.append(newCards);
        howspace.components.init(newRows);
        howspace.components.init(newCards);
        if (table.find('thead th:first-child input[type="checkbox"]').prop('checked')) {
            newRows.find('input[type="checkbox"]:first').prop('checked', true);
        }
        howspace.dispatchEvent(lister, howspace.components.lister.LIST_ITEMS_LOADED, response);
        const newHeight = lister.height();
        const duration = howspace.getAnimationDuration(lister, '--transition-animation-duration');
        lister.height(origHeight).css('overflow', 'clip');
        howspace.animate(lister, {height : newHeight}, duration, () => {
            real.infiniteScroll.resume(lister);
            lister.css({
                height : '',
                overflow : ''
            });
            howspace.dispatchEvent(lister, howspace.components.lister.LIST_ITEMS_RENDERED, response);
        });
    };

    const getNextItemsPageUrl = (lister, href) => {
        if (href && href.includes('limit=') && lister.data('limit') && lister.data('first-page-limit')) {
            href = href.replace(/limit=\d+/, 'limit=' + lister.data('limit'));
        }
        return href;
    };

    const initInfiniteScroll = lister => {
        if (lister.is('.real-infinite-scroll-initialized')) {
            real.infiniteScroll.destroy(lister);
        }

        if (lister.is('.real-infinite-scroll')) {
            real.infiniteScroll.init(lister, {
                url : getUrl(lister),
                scrollElement : howspace.getClosestScrollingParent(lister),
                getNextPageUrlFromResponse : (response) => {
                    return getNextItemsPageUrl(lister, response['next_page_href']);
                },
                successFn : (response) => {
                    real.infiniteScroll.pause(lister);
                    lister.dataAndAttr('next-items-page-href', getNextItemsPageUrl(lister, response['next_page_href']));
                    renderListItems(lister, response);
                }
            });

            real.infiniteScroll.pause(lister);
        }
    };

    /**
     * Ends a load that has nowhere to load from, through the ordinary empty result so the lister lands in
     * exactly the state a genuinely empty list does.
     *
     * getUrl builds its request by appending the query string to data-uri, so without one the request goes
     * to the current document and comes back as HTML the lister cannot read.
     */
    const settleWithNoItems = lister => {
        lister.removeDataAndAttr('next-items-page-href');
        // Rendered without the loader to empty transition. There is nothing to animate between, and the
        // transition is a chain of animation callbacks that a page still settling around the lister can cut
        // short, which left the loader up for good in the AI builder preview. A synchronous render cannot.
        lister.dataAndAttr('reload-without-animation', true);
        renderListItems(lister, {total_items: 0, next_page_href: null, table_html: '', cards_html: ''});
    };

    /**
     * Starts the first load of a lister that pages with a button. A lister with nowhere to load from settles
     * straight away instead of going through the button: the AI builder preview disables every button on
     * the page as it arrives, and a click on a disabled button never reaches the handler, which left such a
     * lister showing its loader for good.
     */
    const startFirstLoad = (lister, loadMoreButton) => {
        if (!lister.data('uri') && !loadMoreButton.data('next-items-page-href')) {
            loadMoreButton.addClass('d-none');
            settleWithNoItems(lister);
            return;
        }

        loadMoreButton.trigger('click');
    };

    const loadFirstPageOfItems = lister => {
        let ajax = lister.data('loading-items-ajax');
        if (typeof ajax?.abort === 'function') {
            ajax.abort();
        }

        if (!lister.data('uri')) {
            settleWithNoItems(lister);
            return;
        }

        ajax = real.ajax.json(getUrl(lister), {
            type : 'GET',
            success : (response) => {
                lister.removeDataAndAttr('next-items-page-href');
                renderListItems(lister, response);
            },
            complete : () => {
                lister.removeData('loading-items-ajax');
            }
        });
        lister.data('loading-items-ajax', ajax);
    };

    const reset = lister => {
        if (lister.length === 0) {
            return;
        }

        const loader = lister.find('.howspace-lister-loader');
        const cards = lister.find('.howspace-lister-cards');
        const table = lister.find('.howspace-lister-table');
        const noItems = lister.find('.howspace-lister-no-items');
        const emptyState = lister.find('.howspace-lister-empty-state');
        const loadMoreButton = lister.find('.lister-load-more-btn');

        // Reset items counts.
        lister.dataAndAttr('total-items', 0);
        lister.dataAndAttr('has-more-items', false);

        // Hide the load more button.
        loadMoreButton.removeDataAndAttr('next-items-page-href').addClass('d-none');
        noItems.removeAttr('style');
        emptyState.removeAttr('style');

        const readyFn = () => {
            // Reset the UI.
            lister.addClass('loading');
            cards.html('');
            table.find('tbody').html('');
            lister.find('.howspace-table thead th:first-child input[type="checkbox"]').prop('checked', false);

            if (lister.is('.real-infinite-scroll')) {
                initInfiniteScroll(lister);
            } else if (loadMoreButton.length > 0) {
                startFirstLoad(lister, loadMoreButton);
            } else {
                loadFirstPageOfItems(lister);
            }
        };

        if (cards.is(':visible')) {
            transition(lister, cards, loader, readyFn);
        } else if (table.is(':visible')) {
            stopObservingTable(table);
            transition(lister, table, loader, readyFn);
        } else if (noItems.is(':visible')) {
            transition(lister, noItems, loader, readyFn);
        } else if (emptyState.is(':visible')) {
            transition(lister, emptyState, loader, readyFn);
        } else {
            readyFn();
        }
    };

    const reloadWithoutAnimation = lister => {
        if (lister.length === 0) {
            return;
        }

        lister.dataAndAttr('reload-without-animation', true);

        // Reset items counts.
        lister.dataAndAttr('total-items', 0);
        lister.dataAndAttr('has-more-items', false);

        if (lister.is('.real-infinite-scroll')) {
            initInfiniteScroll(lister);
        } else {
            const loadMoreButton = lister.find('.lister-load-more-btn');
            if (loadMoreButton.length > 0) {
                loadMoreButton.removeDataAndAttr('next-items-page-href').addClass('d-none');
                loadMoreButton.click();
            } else {
                loadFirstPageOfItems(lister);
            }
        }
    };

    const sortTable = (e) => {
        const btn = $(e.target);
        const table = btn.closest('.howspace-table');
        const lister = table.closest('.howspace-lister');
        const activeSortBtn = table.find('.btn.active[data-sort-by]');

        if (btn[0] === activeSortBtn[0]) {
            btn.dataAndAttr('sort-order', btn.data('sort-order') === 'asc' ? 'desc' : 'asc');
        } else {
            activeSortBtn.removeClass('active').removeDataAndAttr('sort-order');
            btn.addClass('active');
            btn.dataAndAttr('sort-order', btn.data('sort-reverse') ? 'desc' : 'asc');
        }

        lister.dataAndAttr('sort-by', btn.data('sort-by'));
        lister.dataAndAttr('sort-order', btn.data('sort-order'));

        reset(lister);
    };

    const search = e => {
        reset($(e.target).closest('.howspace-lister'));
    };

    document.body.addEventListener('click', e => {
        if (e.target && e.target.classList && e.target.classList.contains('howspace-lister-mode-btn')) {
            // Change all lister components to another mode.
            const btn = $(e.target);
            btn.parent().find('.btn.active').removeClass('active');
            btn.addClass('active');
            $('.howspace-lister.howspace-lister-initialized').each(function() {
                handleChangeMode($(e.target), $(this));
            });
        }
    });

    const handleChangeMode = (btn, lister) => {
        const btnMode = btn.data('mode');
        const listerMode = lister.data('mode');

        if (btnMode === listerMode) {
            // Lister is already in the right mode.
            return;
        }

        lister.find('.howspace-lister-mode-btn.active').removeClass('active');
        btn.addClass('active');

        const cards = lister.find('.howspace-lister-cards');
        const table = lister.find('.howspace-lister-table');

        if (lister.is('.no-items')) {
            lister.dataAndAttr('mode', btnMode);
            return;
        }

        if (btnMode === 'table') {
            transition(lister, cards, table, () => {
                startObservingTable(table);
            }, () => {
                lister.dataAndAttr('mode', btnMode);
                cards.hide();
                table.show();
                lister.trigger(howspace.components.lister.TABLE_VIEW_SELECTED);
            });
        } else {
            transition(lister, table, cards, null, () => {
                lister.dataAndAttr('mode', btnMode);
                stopObservingTable(table);
                cards.show();
                table.hide();
                lister.trigger(howspace.components.lister.CARD_VIEW_SELECTED);
            }, () => {
                // Change mode to cards just before calculating lister items height.
                lister.dataAndAttr('mode', 'cards');
            }, () => {
                // Restore mode back to table after height calculation.
                lister.dataAndAttr('mode', 'table');
            });
        }
    };

    const toggleSelectAll = (e) => {
        const checkbox = $(e.target);
        const table = checkbox.closest('table');
        const lister = table.closest('.howspace-lister');

        table.find('tbody tr > *:first-child input[type="checkbox"]').prop('checked', checkbox.prop('checked'));

        if (checkbox.prop('checked')) {
            lister.trigger(howspace.components.lister.ALL_ITEMS_SELECTED);
        } else {
            lister.trigger(howspace.components.lister.ALL_ITEMS_UNSELECTED);
        }
    };

    const toggleSelect = (e) => {
        const checkbox = $(e.target);
        const table = checkbox.closest('table');
        const lister = table.closest('.howspace-lister');

        if (checkbox.prop('checked')) {
            lister.trigger(howspace.components.lister.ITEM_SELECTED, [checkbox.closest('tr')]);
        } else {
            lister.trigger(howspace.components.lister.ITEM_UNSELECTED, [checkbox.closest('tr')]);

            if (table.find('input[type="checkbox"]:checked').length === 0) {
                lister.trigger(howspace.components.lister.ALL_ITEMS_UNSELECTED);
            }

            table.find('thead th:first-child input[type="checkbox"]').prop('checked', false);
        }
    };

    const loadMoreButtonClickHandler = (e) => {
        const btn = $(e.target);

        if (real.button.isLoading(btn)) {
            return;
        }

        real.button.loading(btn);

        const lister = btn.closest('.howspace-lister');

        let ajax = lister.data('loading-items-ajax');
        if (typeof ajax?.abort === 'function') {
            // Abort the previous ajax request.
            ajax.abort();
        }

        if (!btn.data('next-items-page-href') && !lister.data('uri')) {
            real.button.reset(btn);
            btn.addClass('d-none');
            settleWithNoItems(lister);
            return;
        }

        let isRequesting = true;
        const url = btn.data('next-items-page-href') || getUrl(lister);

        ajax = real.ajax.json(url, {
            type : 'GET',
            success : (response) => {
                isRequesting = false;
                real.button.reset(btn);
                if (response.next_page_href) {
                    btn.dataAndAttr('next-items-page-href', getNextItemsPageUrl(lister, response.next_page_href));
                } else {
                    btn.removeDataAndAttr('next-items-page-href');
                    btn.addClass('d-none').removeAttr('style');
                }
                howspace.idleCallback(() => {
                    if (!isRequesting) {
                        renderListItems(lister, response);
                    }
                });
            },
            complete : () => {
                lister.removeData('loading-items-ajax');
            }
        });
        lister.data('loading-items-ajax', ajax);
    };

    /**
     * Update frozen column th and td sticky offset left CSS variables.
     * @param lister
     */
    const updateFrozenColumns = lister => {
        const listerItems = lister.find('.howspace-lister-items');

        if (!listerItems.is('.freeze-columns-enabled')) {
            // No columns are frozen.
            return;
        }

        // Disable column freeze functionality for the duration of the size calculations.
        listerItems.removeClass('freeze-columns-enabled');

        // Start by finding out the index of the last frozen column.
        const table = listerItems.find('.howspace-table');
        let lastFrozenColumnIndex = 0;
        table.find('thead th').each((index, th) => {
            if(th.classList.contains('frozen')) {
                lastFrozenColumnIndex = index;
            }
        });

        let offsetLeft = 0;
        table.find('thead th').each((index, th) => {
            th = $(th);
            th.removeClass('last-frozen');
            if(!th.is('.frozen')) {
                // The thead th element is not frozen, skip to next.
                return true;
            }

            // Set the thead th element offset left CSS variable.
            th.css('--sticky-offset-left', offsetLeft + 'px');

            // Set the tbody td elements offset left CSS variables and update frozen classes.
            const td = table.find('tbody tr > *:nth-child(' + (index + 1) + ')');
            td.removeClass('last-frozen').addClass('frozen').css('--sticky-offset-left', offsetLeft + 'px');

            if(index === lastFrozenColumnIndex) {
                // This is the last frozen column, add "last-frozen" classes.
                th.addClass('last-frozen');
                table.find('tbody tr > *:nth-child(' + (index + 1) + ')').addClass('last-frozen');
            }

            // Increment the offset left with the frozen th width.
            offsetLeft += th.outerWidth();
        });

        // Re-enable column freeze if one or more columns are frozen.
        if (table.find('thead th.frozen').length > 0) {
            listerItems.addClass('freeze-columns-enabled');
        }
    };

    return {
        LIST_ITEMS_LOADED : 'howspace-components-lister-list-items-loaded',
        LIST_ITEMS_RENDERED : 'howspace-components-lister-list-items-rendered',
        ITEM_SELECTED : 'howspace-components-lister-item-selected',
        ITEM_UNSELECTED : 'howspace-components-lister-item-unselected',
        ALL_ITEMS_SELECTED : 'howspace-components-lister-all-items-selected',
        ALL_ITEMS_UNSELECTED : 'howspace-components-lister-all-items-unselected',
        CARD_VIEW_SELECTED : 'howspace-components-lister-card-view-selected',
        TABLE_VIEW_SELECTED : 'howspace-components-lister-table-view-selected',
        init : (elem) => {
            elem.findIncludingSelf('.howspace-lister:not(.howspace-lister-initialized, [data-init="false"])')
                .each(function() {
                    const lister = $(this);
                    const table = lister.find('.howspace-table');
                    const cards = lister.find('.howspace-lister-cards');

                    lister.addClass('howspace-lister-initialized');

                    table.on('click', 'thead .btn[data-sort-by]', sortTable);
                    table.on('change', 'thead th:first-child input[type="checkbox"]', toggleSelectAll);
                    table.on('change', 'tbody tr > *:first-child input[type="checkbox"]', toggleSelect);

                    lister.find('.howspace-form-search-input').on(howspace.components.searchInput.SEARCH, search);

                    // Reset the content of the lister.
                    cards.html('');
                    table.find('tbody').html('');

                    if (lister.is('.real-infinite-scroll')) {
                        initInfiniteScroll(lister);
                    } else {
                        const loadMoreButton = lister.find('.lister-load-more-btn');
                        if (loadMoreButton.length > 0) {
                            loadMoreButton.on('click', loadMoreButtonClickHandler);
                            startFirstLoad(lister, loadMoreButton);
                        } else {
                            loadFirstPageOfItems(lister);
                        }
                    }
                }
            );
        },
        destroy : (elem) => {
            elem.findIncludingSelf('.howspace-lister.howspace-lister-initialized')
                .each(function() {
                    const lister = $(this);
                    const table = lister.find('.howspace-table');

                    lister.removeClass('howspace-lister-initialized');

                    table.off('click', 'thead .btn[data-sort-by]', sortTable);
                    table.off('change', 'thead th:first-child input[type="checkbox"]', toggleSelectAll);
                    table.off('change', 'tbody tr > *:first-child input[type="checkbox"]', toggleSelect);

                    lister.find('.howspace-form-search-input').off(howspace.components.searchInput.SEARCH, search);
                    if (lister.is('.real-infinite-scroll-initialized')) {
                        real.infiniteScroll.destroy(lister);
                    } else {
                        lister.find('.lister-load-more-btn').off('click', loadMoreButtonClickHandler);
                    }

                    stopObservingTable(table);
                }
            );
        },
        reload : elem => {
            elem.findIncludingSelf('.howspace-lister.howspace-lister-initialized')
                .each(function() {
                    const lister = $(this);
                    reset(lister);
                }
            );
        },
        reloadWithoutAnimation : reloadWithoutAnimation,
        freezeColumn : (lister, columnNumber) => {
            lister.find('.howspace-lister-items').addClass('freeze-columns-enabled');
            lister.find('.howspace-table tr > *:nth-child(' + columnNumber + ')').addClass('frozen');
            updateFrozenColumns(lister);
        },
        unfreezeColumn : (lister, columnNumber) => {
            lister.find('.howspace-table tr > *:nth-child(' + columnNumber + ')').removeClass('frozen');
            updateFrozenColumns(lister);
        },
        isSelectAllChecked : lister => {
            const table = lister.find('.howspace-table');

            return table.find('thead th:first-child input[type="checkbox"]').prop('checked');
        },
        getSelectedItems : lister => {
            const table = lister.find('.howspace-table');

            return table.find('tbody tr:has(input[type="checkbox"]:checked)');
        },
        selectAllItems : lister => {
            const table = lister.find('.howspace-table');

            table.find('thead th:first-child input[type="checkbox"]').prop('checked', true).change();
        },
        unselectAllItems : lister => {
            const table = lister.find('.howspace-table');

            table.find('thead th:first-child input[type="checkbox"]').prop('checked', false).change();
        },
        render : (lister, response) => {
            if (lister.length === 0) {
                return;
            }
            lister.data('reload-without-animation', true); // Triggers clean slate.
            renderListItems(lister, response);
        },
        updateItemsCount : (lister, diff) => {
            if (!lister || lister.length === 0) {
                return;
            }
            if (!(lister instanceof jQuery)) {
                lister = $(lister);
            }
            const tab = $(lister.data('tab-selector'));
            const totalItems = lister.data('total-items') + diff;
            tab.find('.howspace-lister-items-count').html('(' + totalItems + ')');
            lister.dataAndAttr('total-items', totalItems);
        }
    };

})();
